<template>
  <v-row>
    <v-row dense>
      <v-col>
        <v-text-field
          dense
          :value="filters.fileName"
          solo
          label="Поиск"
          prepend-inner-icon="mdi-magnify"
          @change="$emit('change-filters', { field: 'fileName', value: $event})"
        ></v-text-field>
      </v-col>
      <v-col>
        <v-checkbox
          dense
          :disabled="!count && !filters.selected"
          :value="filters.selected"
          :input-value="filters.selected"
          :label="`Только выбранные (${count})`"
          @change="$emit('change-filters', { field: 'selected', value: $event})"
        />
      </v-col>
      <v-col>
        <v-select
          dense
          :value="filters.type"
          :items="$options.mediaFileTypes"
          :disabled="fileTypeDisabled"
          label="Тип"
          item-value="value"
          item-text="text"
          solo
          @change="$emit('change-filters', { field: 'type', value: $event})"
        />
      </v-col>
      <v-col>
        <v-select
          dense
          :value="filters.sort"
          :items="$options.mediaSortOptions"
          label="Упорядочить"
          solo
          item-value="value"
          item-text="text"
          @change="$emit('change-filters', { field: 'sort', value: $event})"
        />
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="auto">
        <v-checkbox
          dense
          :disabled="!count"
          :value="filters.autoSort"
          :input-value="filters.autoSort"
          :label="'Автосортировка выбранных'"
          @change="updateAutoSortHandler"
        />
      </v-col>
      <v-col cols="auto">
        <v-checkbox
          dense
          :disabled="!count"
          :value="filters.hideSelected"
          :input-value="filters.hideSelected"
          :label="'Скрыть выбранные'"
          @change="$emit('change-filters', { field: 'hideSelected', value: $event})"
        />
      </v-col>
    </v-row>
  </v-row>
</template>

<script>
import mediaFileTypes from '@/configs/mediaFileTypes'
import mediaSortOptions from '@/configs/mediaSortOptions'
export default {
  name: 'media-file-picker-form',
  mediaFileTypes,
  mediaSortOptions,
  props: {
    filters: {
      type: Object,
      default: () => ({})
    },
    count: {
      type: Number,
      required: true,
      default: null
    },
    fileType: {
      type: String,
      default: null
    },
    fileTypeDisabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    updateAutoSortHandler (value) {
      this.$emit('change-filters', { field: 'autoSort', value })
      this.$emit('sort')
    }
  }
}
</script>
